import React from "react";
import { 
  ArrowRightIcon, 
  SunIcon,
  PlusIcon, // 14 Apr 2026
  MinusIcon,// 14 Apr 2026
} from "@heroicons/react/24/outline";

import EtWabReflectionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabReflectionIcon1SVGComp";
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp";
import EtWabCreationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabCreationIcon1SVGComp";
import EtMagnetizationSelfIcon2SVGComp from "@/assets/img/icons/svgComp/EtMagnetizationSelfIcon2SVGComp";

import EtImprintPurposeIcon1SVGComp from "@/assets/img/icons/svgComp/EtImprintPurposeIcon1SVGComp";
import EtImprintPurposeNameIcon3SVGComp from "@/assets/img/icons/svgComp/EtImprintPurposeNameIcon3SVGComp";

const EtTrinityOnboardingUnlockSelf = () => {
  // Author - Atul Pandey
  // First Created - 31 Mar 2026
  // Purpose - Unlock Yourself section for Trinity onboarding
  // Updated - 02 Apr 2026 - Added Purpose + Performance
  // Updated - 02 Apr 2026 - Rich detail for first three
  // Updated - 02 Apr 2026 - Grid layout (2-column responsive)
  // Updated - 11 Apr 2026 - Copy changes - Unlock Yourself- Perspectives - Induction
  // Updated - 12 Apr 2026 - Copy changes - Unlock Yourself- Purpose - Induction
  // Updated - 13 Apr 2026 - Copy changes - Unlock Yourself- Actions - Induction
  // Updated - 13 Apr 2026 - JSX styling refinement - unlockYourself array
  // Updated - 14 Apr 2026 - JSX styling refinement - card show / hide details toggle


  // 1 -  State variable for show/hide toggle - 14 Apr 2026
  const [expandedCards, setExpandedCards] = React.useState({});

  // 2 - Handle ToggleCard function - 14 Apr 2026
  const toggleCard = (cardId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardId]: !prev[cardId],
    }));
  };

  // 3 - Unlock Yourself Array  
  const unlockYourself = [
    {
      id: "routine",
      unlock: "Unlock Your Routine",
      area: "Morning Habits",
      Icon: SunIcon,
      detailType: "rich",
      intro:
        "Your aspiration for high performance will remain unfulfilled if you have weak energy and low everyday readiness.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Pressure and stress in your role can{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              burn you out
            </span>{" "}
            and reduce your ability to innovate and stay ahead unless you build a strong rhythm of{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-[11px]">
              daily energization
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This is{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              not discretionary
            </span>{" "}
            if you are serious about building high performance growth. Your{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              health habits
            </span>{" "}
            must become a{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              non negotiable
            </span>{" "}
            part of your daily routine.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity helps you power up your{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-[11px]">
              core energy plexus
            </span>{" "}
            every morning and build a visible{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              streak
            </span>{" "}
            of energization over time.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Go to the{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              "Where to Begin"
            </span>{" "}
            section and follow the{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Nav Path
            </span>{" "}
            to create a track for this routine with clear guidance for getting started.
          </p>
        ),
      ],
      closing:
        "Start building this habit first to strengthen your personal and professional effectiveness.",
    },

    {
      id: "intellect",
      unlock: "Unlock Your Intellect",
      area: "Reflections",
      Icon: EtWabReflectionIcon1SVGComp,
      detailType: "rich",
      intro:
        "The business of tech thrives on constant innovation and therefore your intellect must remain razor sharp if you want to stay differentiated.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            With{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              AI
            </span>{" "}
            taking more mindspace with clients, your ability to think with{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              clarity and originality
            </span>{" "}
            is now a matter of existence.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            You must build a powerful{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              thinking muscle
            </span>{" "}
            which is practiced and refined every day in a{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              deliberate way
            </span>{" "}
            and not in a reactive way.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Most leaders have{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              scattered thinking
            </span>{" "}
            without structure, evidence or usable clarity.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity helps you break that chaos by building a habit of{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              reflections
            </span>{" "}
            through logging your observations, accomplishments, challenges and perspectives.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Go to the{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              "Where to Begin"
            </span>{" "}
            section and follow the{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Nav Path
            </span>{" "}
            to start logging your reflections.
          </p>
        ),
      ],
      closing:
        "Start building this habit to strengthen your thought leadership in a visible and deliberate way.",
    },

    {
      id: "creativeHorsepower",
      unlock: "Unlock Your Creative Horsepower",
      area: "Creations",
      Icon: EtWabCreationIcon1SVGComp,
      detailType: "rich",
      intro:
        "Your role as a growth creator requires you to convert your thoughts into reusable influence building assets.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Reflections
            </span>{" "}
            grow your thought leadership,{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Creations
            </span>{" "}
            help you leverage it.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            They build your{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              presence
            </span>
            ,{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              brand recall
            </span>{" "}
            and create{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              pull
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity helps you build, organize and leverage{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              creations daily
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            From{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              articles and sales assets
            </span>{" "}
            to deeper assets like{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              books, patents and podcasts
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Go to{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              "Where to Begin"
            </span>{" "}
            and start logging your creations.
          </p>
        ),
      ],
      closing:
        "Start building this habit to imprint your thought leadership into lasting assets.",
    },

    {
      id: "presence",
      unlock: "Unlock Your Presence",
      area: "Conversations",
      Icon: EtWabConversationIcon1SVGComp,
      detailType: "rich",
      intro:
        "Creating growth is a function of building deep and trusted relationships where your thought leadership helps uncover opportunities to create greater value for your clients.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Raise your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              consultative posture
            </span>{" "}
            through purposeful conversations that investigate problems and build awareness.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Conversations are the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-[11px]">
              leading indicator
            </span>{" "}
            of a healthy growth pipeline, not cursory meet and greet or order taking interactions.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Develop the ability to{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              challenge thinking
            </span>
            , surface problems, and guide clients toward solutions.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Move beyond informal chats and formal reviews like{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              MBRs and QBRs
            </span>{" "}
            that often fail to create real learning.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Logging conversations directly is{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              critical
            </span>
            , as informal and one on one interactions are otherwise lost.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity helps you build this muscle by making{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              conversation logging
            </span>{" "}
            a daily habit.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            The more you log in your own words, the deeper you connect with{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              client context
            </span>{" "}
            and improve future conversations.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Reflections and Creations
            </span>{" "}
            strengthen your thinking,{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Conversations
            </span>{" "}
            help you apply it to create growth.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Conversations lead to{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Propositions
            </span>
            , then{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Negotiations
            </span>
            , and ultimately{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Conversions into Wins
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Go to{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              "Where to Begin"
            </span>{" "}
            and follow the path to start logging your conversations in the{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Conversations Center
            </span>
            .
          </p>
        ),
      ],
      closing:
        "Start building this habit daily and watch your pipeline, confidence, and influence grow over time.",
    },

    {
      id: "perspectives",
      unlock: "Unlock Your Perspectives",
      area: "Induction",
      Icon: EtMagnetizationSelfIcon2SVGComp,
      detailType: "rich",
      intro:
        "A big part of unlocking your growth happens when you create deliberate space to introspect, investigate, and imagine possibilities into new realities.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Induce{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              thought provoking thinking
            </span>{" "}
            by tapping into your own experiences and supplementing them with perspectives from your ecosystem.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Leverage your{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              team, sponsors, advisors, and coaches
            </span>{" "}
            to continuously refine and deepen your thinking.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This assimilation builds a richer reservoir of{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              impactful and innovative thoughts
            </span>{" "}
            over time.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Your ability to discover{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              new ideas and perspectives
            </span>{" "}
            starts to grow exponentially.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This is where you truly harness the power of the{" "}
            <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-orange-100 border border-orange-200 text-orange-800 font-semibold text-[11px]">
              collective
            </span>{" "}
            to expand the realms of your thinking.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity’s{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Induction space
            </span>{" "}
            is designed to help you deliberately unlock and shape your thinking.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            It is{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              not a dump of meeting notes
            </span>
            , but a space to connect deliberate thinking to meaningful{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Actions
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Choose a{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Trail
            </span>
            , capture your thoughts through self reflection or guided sessions with your coach or sponsor.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Use{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Session Notes
            </span>{" "}
            for your own thinking, and share selectively with your team when needed.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Coach Notes
            </span>{" "}
            and{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Sponsor Notes
            </span>{" "}
            bring in external perspectives to enrich your thinking.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            The true power of Induction lies in translating perspectives into{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              Actions
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Track actions created by{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              you, your coach, your sponsor, or Trinity
            </span>{" "}
            in a structured way.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            As you keep adding notes, Trinity nudges you with{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              insights and next steps
            </span>{" "}
            to move forward.
          </p>
        ),
      ],
      closing:
        "Start capturing your thoughts more deliberately and watch your perspectives evolve into powerful action and thought leadership over time.",
    },

    {
      id: "purpose",
      unlock: "Unlock Your Purpose",
      area: "Induction",
      Icon: EtImprintPurposeIcon1SVGComp,
      detailType: "rich",
      intro:
        "Building high performance growth is not a one time activity, but a continuous process driven by powerful habits that sustain and grow momentum.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This requires an unwavering focus on{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              continuous planning and continuous execution
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Develop the discipline to stay shielded from{" "}
            <span className="font-semibold text-red-700 bg-red-50 px-2 rounded-full">
              distractions of momentary ease
            </span>{" "}
            and unnecessary relaxations.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            A strong sense of{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Purpose
            </span>
            , a sense of{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              mission
            </span>
            , is critical to embrace and live a Purpose Native journey.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Purpose builds a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              laser focused daily operating discipline
            </span>{" "}
            to convert your thoughts into growth outcomes.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity’s{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Induction space
            </span>{" "}
            helps you investigate and articulate your Purpose step by step.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            It enables you to break your Purpose into{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              tangible missions
            </span>{" "}
            with measurable, metric driven goals.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            These goals connect directly to{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              actions
            </span>{" "}
            that drive a sense of mission accomplishment.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Once your Purpose is outlined, you can capture it as{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Missions and Mission Goals
            </span>{" "}
            in Trinity’s Imprint.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Your daily habits across{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Reflections, Creations, Conversations, and Actions
            </span>{" "}
            then align to these Missions.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This creates a{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              clear and connected view
            </span>{" "}
            of your performance against your Purpose.
          </p>
        ),
      ],
      closing:
        "As your Purpose connects to your daily habits and execution, your Purpose Native journey becomes fully activated and comes alive.",
    },

    {
      id: "performance",
      unlock: "Unlock Your Performance",
      area: "Actions",
      Icon: EtImprintPurposeNameIcon3SVGComp,
      detailType: "rich",
      intro:
        "Actions are the most tangible determinants of your performance and how your Purpose Native journey translates into real growth outcomes.",
      points: [
        () => (
          <p className="text-xs text-gray-600 leading-6">
            All foundational habit shifts like{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Reflections, Morning Energizations, Creations, and Conversations
            </span>{" "}
            are actions performed consistently.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            In Trinity’s Purpose Native backbone, Actions act as the{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              nerves carrying performance signals
            </span>{" "}
            connected to your purpose centric missions.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Most habits act as{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              enablers
            </span>
            , while true performance is measured through{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              outcomes
            </span>{" "}
            driven by these habits.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Outcome achievement requires multiple{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              enabling actions
            </span>{" "}
            executed with discipline and intent.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            For example, building a pipeline requires actions like{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              account mapping, stakeholder targeting, pitch creation, engagement, and conversion
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Actions can be{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              one time
            </span>{" "}
            or{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              recurring
            </span>{" "}
            based on the nature of your role and responsibilities.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Recurring actions are{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              planned, routine actions
            </span>{" "}
            that build consistency in execution.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Actions can also be{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              self owned
            </span>{" "}
            or performed{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              collectively
            </span>{" "}
            with your team or ecosystem.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Trinity helps you structure and connect all these nuances to your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              mission performance
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Outcome based actions roll up performance signals upward across{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              Mission Goals and Goal Periods
            </span>
            .
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Action types in Trinity span across{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Enabler and Outcome
            </span>
            ,{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              One Time and Recurring
            </span>
            ,{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Assigned and Self owned
            </span>{" "}
            combinations.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            This structured approach helps you clearly track how your{" "}
            <span className="font-semibold text-gray-800 bg-orange-100 px-2 rounded-full">
              execution
            </span>{" "}
            is contributing to outcomes.
          </p>
        ),
        () => (
          <p className="text-xs text-gray-600 leading-6">
            Go to the{" "}
            <span className="font-semibold text-gray-800 bg-gray-100 px-2 rounded-full">
              "Where to Begin"
            </span>{" "}
            section to get started with creating and managing your{" "}
            <span className="font-semibold text-orange-700 bg-orange-50 px-2 rounded-full">
              Actions
            </span>
            .
          </p>
        ),
      ],
      closing:
        "Keep updating your Action Progress and Performance to see your execution translate into visible performance streaks, both individually and collectively.",
    },
  ];

  return (
    <div>
      {/* 1️⃣ Intro */}
      <p className="text-sm font-bold text-gray-800">Unlock Yourself</p>

      <p className="text-xs text-gray-600 mt-1 leading-6">
        {/* As a growth aspiring leader, your readiness matters the most. Trinity
        helps you strengthen the full spectrum of personal growth across energy,
        thinking, expression, purpose and execution. */}
        {/* 13 Apr 2026 */}
        {/* As a growth aspiring leader, your readiness matters the most. Trinity
        helps you unlock the full spectrum of your personal and professional growth foundations including your energy,thinking, expressions, purpose and execution. */}
        As a growth aspiring leader, your readiness matters the most. Trinity
        helps you unlock the full spectrum of your personal and professional growth foundations.
      </p>

      {/* 2️⃣ Grid Layout */}
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {unlockYourself.map(
          ({
            id,
            unlock,
            area,
            Icon,
            detailType,
            intro,
            points,
            closing,
            desc,
          }) => {
            const isExpanded = !!expandedCards[id];

            return (
              <div
                key={id}
                className="bg-gray-50 border border-gray-200 rounded p-4 h-full flex flex-col"
              >
                {/* Header */}
                <div className="flex items-start justify-between">
                  <div className="flex items-start flex-1">
                    <div className="flex justify-center items-center w-10 h-10 rounded-full bg-white border border-orange-100 shadow-sm">
                      <Icon className="h-8 w-8 text-orange-600" />
                    </div>

                    <div className="ml-3">
                      <p className="text-sm font-bold text-gray-800">{unlock}</p>
                      <p className="text-[11px] font-semibold text-orange-700 mt-1 uppercase tracking-wide">
                        {area}
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={() => toggleCard(id)}
                    className="ml-3 flex-shrink-0 rounded-full border border-gray-200 bg-white p-1 hover:bg-orange-50 hover:border-orange-200 transition"
                  >
                    {isExpanded ? (
                      <MinusIcon className="h-4 w-4 text-orange-600" />
                    ) : (
                      <PlusIcon className="h-4 w-4 text-orange-600" />
                    )}
                  </button>
                </div>

                {/* Rich content */}
                {detailType === "rich" ? (
                  <div className="mt-4 pl-12 flex-1">
                    <p className="text-xs text-gray-700 leading-6">{intro}</p>

                     {isExpanded && ( 
                      <>
                     
                          <div className="mt-3 space-y-2">
                            {points.map((point, index) => (
                              <div key={index} className="flex items-start">
                                <span className="text-orange-600 text-xs font-bold mr-2 mt-1">
                                  {index + 1}.
                                </span>

                                <div className="flex-1">
                                  {typeof point === "function" ? (
                                    point()
                                  ) : (
                                    <p className="text-xs text-gray-600 leading-6">{point}</p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        
                    

                        <div className="mt-3 bg-white border border-orange-100 rounded p-3">
                          <p className="text-xs text-gray-700 leading-6">{closing}</p>
                        </div> 
                      </>)}
                    
                  </div>
                ) : (
                  isExpanded && (
                    <div className="mt-3 pl-12 flex-1">
                      <p className="text-xs text-gray-600 leading-6">{desc}</p>
                    </div>
                  )
                )}
              </div>
            );
          }
        )}
      </div>

      {/* 3️⃣ Closing */}
      <div className="mt-4 bg-orange-50 border border-orange-100 rounded p-3">
        <p className="text-xs text-gray-700 leading-5">
          "Where to Begin" helps you start. Unlock Yourself shows the deeper dimensions
          you continue strengthening through Trinity over time.
        </p>
      </div>
    </div>
  );
};

export default EtTrinityOnboardingUnlockSelf;